import script from "./ProjectComments.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectComments.vue?vue&type=script&setup=true&lang=js"

import "./ProjectComments.vue?vue&type=style&index=0&id=61a485bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a485bb"]])

export default __exports__